import { render, staticRenderFns } from "./TodolistDetail.vue?vue&type=template&id=48d02272&scoped=true&"
import script from "./TodolistDetail.vue?vue&type=script&lang=js&"
export * from "./TodolistDetail.vue?vue&type=script&lang=js&"
import style0 from "./TodolistDetail.vue?vue&type=style&index=0&id=48d02272&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d02272",
  null
  
)

export default component.exports